// You can write more code here

/* START OF COMPILED CODE */

import StudentGame from '../../GameComponents/PhaserGame/StudentGames/StudentGame';
import DefaultButton from '../../prefabs/GeneralUI/Buttons/DefaultButton';
import HUDButton from '../../prefabs/GeneralUI/Buttons/HUDButton';
import DefinitionExampleView from '../../prefabs/GeneralUI/DefinitionExampleView';
import UIBlocker from '../../prefabs/GeneralUI/UIBlocker';
import PlayerTypingInput from '../../prefabs/StudentGame/PlayerTypingInput';
import SequencedCardDropSite from '../../prefabs/StudentGame/SequencedCardDropSite';
/* START-USER-IMPORTS */
import { Word } from '@/common/types/scopeAndSequence';
import { ControllerType } from '@/common/types/student';
import {
  playWordDefinition,
  playWordInSentence,
  stopAudio,
} from '@/common/utils/audio';
import trackMixpanelEvent from '@/common/utils/mixpanel';
import { getWordGraphemes } from '@/common/utils/scopeAndSequence';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { StudentGameInputHandler } from '@/game/GameComponents/PhaserGame/Input/StudentGameInputHandler';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import RiposteContext from '@/game/GameComponents/PhaserGame/Types/DuelTypes/RiposteTypes';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import {
  MINIGAME_CORRECT_COLOUR,
  MINIGAME_INCORRECT_COLOUR,
  MINIGAME_PURPLE_COLOUR,
} from '@/game/GameComponents/PhaserGame/Types/MinigameTypes';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  animateBitmapColourTransition,
  DoPositiveFeedback,
  DoReinforcementFeedback,
  getAnchorPlugin,
  setBitmapColor,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import {
  playAIWordWithCards,
  playAIWordWithKeyboard,
} from '@/game/GameComponents/PhaserGame/Utils/StudentGameUtils';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';
import DuelWordCreationPanel from '@/game/scenes/DuelScenes/DuelWordCreationPanel';
/* END-USER-IMPORTS */

export default class RiposteUI extends StudentGame {
  constructor() {
    super('RiposteUI');

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // RiposteUI
    const riposteUI = this.add.container(0, 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(this, 0, 0);
    riposteUI.add(uIBlocker);

    // riposteFeedbackContainer
    const riposteFeedbackContainer = this.add.container(512, 384);
    riposteUI.add(riposteFeedbackContainer);

    // riposteFeedbackBacking_1
    const riposteFeedbackBacking_1 = this.add.nineslice(
      0,
      0,
      'fadeOut',
      undefined,
      128,
      16,
      3,
      1,
      1,
      1,
    );
    riposteFeedbackBacking_1.scaleX = -4;
    riposteFeedbackBacking_1.scaleY = 4;
    riposteFeedbackBacking_1.setOrigin(1, 0.5);
    riposteFeedbackBacking_1.alpha = 0.5;
    riposteFeedbackBacking_1.tint = 3023407;
    riposteFeedbackContainer.add(riposteFeedbackBacking_1);

    // riposteFeedbackBacking
    const riposteFeedbackBacking = this.add.nineslice(
      0,
      0,
      'fadeOut',
      undefined,
      128,
      16,
      3,
      1,
      1,
      1,
    );
    riposteFeedbackBacking.scaleX = 4;
    riposteFeedbackBacking.scaleY = 4;
    riposteFeedbackBacking.setOrigin(1, 0.5);
    riposteFeedbackBacking.alpha = 0.5;
    riposteFeedbackBacking.tint = 3023407;
    riposteFeedbackContainer.add(riposteFeedbackBacking);

    // riposteFeedbackText
    const riposteFeedbackText = this.add.bitmapText(
      0,
      0,
      'Aronui',
      'Riposte Successful!',
    );
    riposteFeedbackText.setOrigin(0.5, 0.5);
    riposteFeedbackText.tintTopLeft = 6896829;
    riposteFeedbackText.tintTopRight = 6896829;
    riposteFeedbackText.tintBottomLeft = 6896829;
    riposteFeedbackText.tintBottomRight = 6896829;
    riposteFeedbackText.text = 'Riposte Successful!';
    riposteFeedbackText.fontSize = -36;
    riposteFeedbackContainer.add(riposteFeedbackText);

    // modalContainer
    const modalContainer = this.add.container(800, 512);
    riposteUI.add(modalContainer);

    // nineslice_1
    const nineslice_1 = this.add.nineslice(
      0,
      204,
      'Hud3',
      undefined,
      92,
      36,
      16,
      16,
      16,
      16,
    );
    nineslice_1.scaleX = 4;
    nineslice_1.scaleY = 4;
    modalContainer.add(nineslice_1);

    // submitButton
    const submitButton = new DefaultButton(this, 0, 168);
    modalContainer.add(submitButton);

    // riposteCardsView
    const riposteCardsView = this.add.container(0, 0);
    modalContainer.add(riposteCardsView);

    // riposteHandDropSite
    const riposteHandDropSite = new SequencedCardDropSite(this, 0, 56);
    riposteCardsView.add(riposteHandDropSite);

    // riposteBoardDropSite
    const riposteBoardDropSite = new SequencedCardDropSite(this, 0, -105);
    riposteCardsView.add(riposteBoardDropSite);

    // riposteTypingView
    const riposteTypingView = this.add.container(0, -56);
    modalContainer.add(riposteTypingView);

    // playerTypingInput
    const playerTypingInput = new PlayerTypingInput(this, 0, 0);
    riposteTypingView.add(playerTypingInput);

    // buttons
    const buttons = this.add.container(0, 232);
    buttons.scaleX = 2;
    buttons.scaleY = 2;
    modalContainer.add(buttons);

    // riposteWordExampleButton
    const riposteWordExampleButton = new HUDButton(
      this,
      36,
      0,
      'ui-speak-button',
    );
    buttons.add(riposteWordExampleButton);

    // riposteWordDefintionButton
    const riposteWordDefintionButton = new HUDButton(
      this,
      0,
      0,
      'ui-definition-button',
    );
    buttons.add(riposteWordDefintionButton);

    // riposteRepeatWordButton
    const riposteRepeatWordButton = new HUDButton(
      this,
      -36,
      0,
      'ui-repeat-button',
    );
    buttons.add(riposteRepeatWordButton);

    // riposteHeader
    const riposteHeader = this.add.container(0, -280);
    modalContainer.add(riposteHeader);

    // riposteHeaderBacking
    const riposteHeaderBacking = this.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      100,
      16,
      8,
      8,
      8,
      8,
    );
    riposteHeaderBacking.scaleX = 4;
    riposteHeaderBacking.scaleY = 4;
    riposteHeader.add(riposteHeaderBacking);

    // riposteHeaderText
    const riposteHeaderText = this.add.bitmapText(
      0,
      0,
      'Aronui',
      'Perform Counter',
    );
    riposteHeaderText.setOrigin(0.5, 0.5);
    riposteHeaderText.tintTopLeft = 985612;
    riposteHeaderText.tintTopRight = 985612;
    riposteHeaderText.tintBottomLeft = 985612;
    riposteHeaderText.tintBottomRight = 985612;
    riposteHeaderText.text = 'Perform Counter';
    riposteHeaderText.fontSize = -24;
    riposteHeader.add(riposteHeaderText);

    // definitionExampleView
    const definitionExampleView = new DefinitionExampleView(this, 0, 0);
    this.add.existing(definitionExampleView);

    this.uIBlocker = uIBlocker;
    this.riposteFeedbackText = riposteFeedbackText;
    this.riposteFeedbackContainer = riposteFeedbackContainer;
    this.submitButton = submitButton;
    this.riposteHandDropSite = riposteHandDropSite;
    this.riposteBoardDropSite = riposteBoardDropSite;
    this.riposteCardsView = riposteCardsView;
    this.playerTypingInput = playerTypingInput;
    this.riposteTypingView = riposteTypingView;
    this.riposteWordExampleButton = riposteWordExampleButton;
    this.riposteWordDefintionButton = riposteWordDefintionButton;
    this.riposteRepeatWordButton = riposteRepeatWordButton;
    this.riposteHeaderText = riposteHeaderText;
    this.modalContainer = modalContainer;
    this.definitionExampleView = definitionExampleView;

    this.events.emit('scene-awake');
  }

  private uIBlocker!: UIBlocker;
  private riposteFeedbackText!: Phaser.GameObjects.BitmapText;
  private riposteFeedbackContainer!: Phaser.GameObjects.Container;
  private submitButton!: DefaultButton;
  private riposteHandDropSite!: SequencedCardDropSite;
  private riposteBoardDropSite!: SequencedCardDropSite;
  private riposteCardsView!: Phaser.GameObjects.Container;
  private playerTypingInput!: PlayerTypingInput;
  private riposteTypingView!: Phaser.GameObjects.Container;
  private riposteWordExampleButton!: HUDButton;
  private riposteWordDefintionButton!: HUDButton;
  private riposteRepeatWordButton!: HUDButton;
  private riposteHeaderText!: Phaser.GameObjects.BitmapText;
  private modalContainer!: Phaser.GameObjects.Container;
  private definitionExampleView!: DefinitionExampleView;

  /* START-USER-CODE */
  public currentContext: RiposteContext | null = null;

  override getPlayerTypingInputs() {
    return [this.playerTypingInput];
  }

  override getBoardDropSite() {
    return this.riposteBoardDropSite;
  }

  override getHandDropSite() {
    return this.riposteHandDropSite;
  }

  public isRiposting() {
    return this.modalContainer.visible;
  }

  override getDefinitionExampleView() {
    return this.definitionExampleView;
  }

  override getControlScheme(controllerType: ControllerType) {
    return (
      this.currentContext?.wordCreationPanel?.getControlScheme(
        controllerType,
      ) ?? controllerType
    );
  }

  override getShouldDisplayBoardSlots(): boolean {
    return true;
  }

  create() {
    this.awake();
  }

  awake() {
    this.editorCreate();
    this.modalContainer.setVisible(false);
    this.riposteFeedbackContainer.setVisible(false);
    this.submitButton.controller.setSubmissionCallback(
      this.handleAttemptRiposte.bind(this),
    );

    // Input handler.
    this.inputHandler = new StudentGameInputHandler(this as StudentGame);
    this.inputHandler.updateCurrentInputSystem(
      this.getControlScheme(getStudent().settings.controllerType),
    );

    // Setup the board for the control scheme.
    this.setupBoardForControlScheme(
      this.getControlScheme(getStudent().settings.controllerType),
    );

    // Button callbacks.
    this.riposteWordExampleButton.setSubmissionCallback(() => {
      this.playWordInSentence();
    });
    this.riposteWordDefintionButton.setSubmissionCallback(() => {
      this.playWordDefinition();
    });
    this.riposteRepeatWordButton.setSubmissionCallback(() => {
      const word = this.currentContext?.wordCreationPanel.currentTargetWord;
      if (!word) {
        console.error('No word found');
        return;
      }
      stopAudio();
      playWordInSentence(word);
    });

    // Responsiveness.
    const anchor = getAnchorPlugin(this);
    if (anchor) {
      anchor.add(this.modalContainer, {
        centerX: '50%',
        centerY: '50%',
      });
      anchor.add(this.riposteFeedbackContainer, {
        centerX: '50%',
        centerY: '50%',
      });
    }

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.modalContainer,
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.riposteFeedbackContainer,
      DEFAULT_SCALE_DOWN_CONFIG,
    );

    // Event listeners.
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.WORD_WAS_PLAYED,
      this.handleWordWasPlayed,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.STUDENT_GAME_KEYBOARD_INPUT,
      this.handleStudentGameKeyboardInput,
      this,
    );

    return this;
  }

  newRound() {}

  async promptRiposte(context: RiposteContext) {
    getSceneManager()?.resumeScene('RiposteUI');
    this.setBoardInteractive(false);

    this.currentContext = context;
    const targetWord = context.wordCreationPanel.currentTargetWord;
    if (!targetWord) {
      console.error('No target word found');
      return;
    }
    const controllerType = this.getControlScheme(
      getStudent().settings.controllerType,
    );
    this.setupBoardForControlScheme(controllerType);
    this.inputHandler?.updateCurrentInputSystem(controllerType);

    // Clear existing cards.
    this.clearCards();

    // Generate new cards.
    this.generateNewCards();

    await waitForSeconds(this.time, 1);
    EventBus.emit(GAME_EVENTS.RIPOSTE_STARTED);

    // Play audio for the riposte.
    playWordInSentence(targetWord);
    this.modalContainer.setVisible(true);
    this.uIBlocker.setVisible(true);
    if (context.duelistIndex === 0) {
      // The AI got the word wrong, so the player can perform the riposte.
      this.riposteHeaderText.text = 'Perform Counter';
      this.setBoardInteractive(true);
    } else {
      // The player got the word wrong, so the AI will perform the riposte.
      this.riposteHeaderText.text = 'Opponent Is Countering...';
      this.playAIRiposte();
    }
  }

  async completeRiposte(riposteSuccessful: boolean, word: string) {
    EventBus.emit(GAME_EVENTS.DUELIST_ATTEMPTED_RIPOSTE);
    this.modalContainer.setVisible(false);
    this.getDefinitionExampleView().setVisible(false);
    this.uIBlocker.setVisible(false);
    let riposteResultText = '';
    if (riposteSuccessful) {
      riposteResultText = 'Counter Successful!';
      PhaserAudioManager.playSFX(this, 'riposte-success');
      EventBus.emit(GAME_EVENTS.DUELIST_PERFORMED_RIPOSTE, {
        duelistIndex: this.currentContext?.duelistIndex ?? 0,
        word,
      });
    } else {
      PhaserAudioManager.playSFX(this, 'riposte-failure');
      riposteResultText = 'Counter Failed.';
    }
    this.riposteFeedbackText.text = riposteResultText;
    this.riposteFeedbackContainer.setVisible(true);
    this.clearTypedInput();

    // Do riposte text animation.
    if (riposteSuccessful) {
      DoPositiveFeedback(this, this.riposteFeedbackContainer, {});
    } else {
      DoReinforcementFeedback(this, this.riposteFeedbackContainer);
    }
    const feedbackText = this.riposteFeedbackText;
    const feedbackTextContainer = this.riposteFeedbackContainer;
    const feedbackColor = riposteSuccessful
      ? MINIGAME_CORRECT_COLOUR
      : MINIGAME_INCORRECT_COLOUR;
    const returnColor = MINIGAME_PURPLE_COLOUR;
    setBitmapColor(feedbackText, returnColor);
    this.tweens.add({
      targets: feedbackTextContainer,
      alpha: 1,
      duration: 400,
      ease: 'Linear',
      onComplete: () => {
        animateBitmapColourTransition(
          feedbackText,
          feedbackColor,
          returnColor,
          800,
          false,
        );
      },
    });
    this.tweens.add({
      targets: feedbackTextContainer,
      alpha: 0,
      duration: 800,
      delay: 1200,
      ease: 'Linear',
    });

    await waitForSeconds(this.time, 2.4);
    this.riposteFeedbackContainer.setVisible(false);
  }

  validateRiposte() {
    const { currentContext } = this;
    if (currentContext == null) return { isValid: false, word: '' };
    const attempt = this.getInput();
    const isValid =
      attempt === currentContext.wordCreationPanel.currentTargetWord?.spelling;
    return {
      isValid,
      word: attempt,
    };
  }

  async playAIRiposte() {
    const scheme = this.getControlScheme(getStudent().settings.controllerType);
    this.setBoardInteractive(false);
    this.submitButton.controller.makeInteractive(false);

    if (!this.currentContext?.wordCreationPanel.currentTargetWord) {
      console.error('No target word found');
      return;
    }
    const wordGraphemes = getWordGraphemes(
      this.currentContext?.wordCreationPanel.currentTargetWord,
    );
    const aiSpeedMod = 1;
    await waitForSeconds(this.time, 1.5);

    if (scheme === 'keyboard') {
      await playAIWordWithKeyboard(this, wordGraphemes, aiSpeedMod, () =>
        this.handleAttemptRiposte(),
      );
    } else {
      await playAIWordWithCards(
        this,
        wordGraphemes,
        aiSpeedMod,
        this.currentContext?.wordCreationPanel.currentTargetWord,
        () => this.handleAttemptRiposte(),
      );
    }
  }

  setupBoardForControlScheme(scheme: ControllerType) {
    this.riposteTypingView.setVisible(scheme === ControllerType.KEYBOARD);
    this.riposteCardsView.setVisible(
      scheme === ControllerType.CLICK || scheme === ControllerType.DRAG,
    );
  }

  generateNewCards() {
    const allCards = this.currentContext?.cards ?? [];
    if (!allCards) return;
    for (const card of allCards) {
      const newCard = new StudentGameCard(this, 0, 0);
      this.initializeNewMinigameCard(newCard, card.cardText, 'hand');
    }
  }

  generateTypedWord(forAI?: boolean) {
    this.playerTypingInput.clearInput();
    if (!forAI) {
      const attempt = this.currentContext?.attempt;
      if (!attempt) {
        console.error('No word found');
        return;
      }
      this.playerTypingInput.setInput(attempt);
    }
  }

  initializeNewMinigameCard(
    card: StudentGameCard,
    spelling: string,
    site: string,
  ) {
    card.setCardText(spelling);
    const dropSite =
      site === 'hand' ? this.riposteHandDropSite : this.riposteBoardDropSite;
    dropSite.layoutGroup?.pushCard(card);
    card.origin = {
      dropSite: dropSite,
      index: dropSite.layoutGroup?.cards.indexOf(card) ?? 0,
    };
    this.inputHandler?.initializeCardInput(card);
  }

  override setBoardInteractive(interactive: boolean) {
    this.boardInteractive = interactive;
    this.submitButton.controller.makeInteractive(this.getCanSubmit());
    this.riposteRepeatWordButton.setInteractionEnabled(interactive);
    this.riposteWordExampleButton.setInteractionEnabled(interactive);
    this.riposteWordDefintionButton.setInteractionEnabled(interactive);
    this.getAllCards().forEach((card) => {
      card.makeInteractive(interactive, false);
    });
  }

  override setSubmissionPossible(canSubmit: boolean) {
    this.submitButton.controller.makeInteractive(canSubmit);
  }

  override getCanSubmit() {
    return this.getInput().length > 0;
  }

  override checkAnswer() {
    this.handleAttemptRiposte();
  }

  override shouldShowCardGuidance(): boolean {
    return this.currentContext?.duelistIndex === 1; // The current duelist is the NPC.
  }

  // Fired when the user tries to fire a riposte.
  handleAttemptRiposte() {
    this.setBoardInteractive(false);
    const riposteResult = this.validateRiposte();
    this.completeRiposte(riposteResult.isValid, riposteResult.word);
  }

  handleStudentGameKeyboardInput() {
    const definitionExampleImageView = this.getDefinitionExampleView();
    this.tweens.killTweensOf(definitionExampleImageView);
    definitionExampleImageView.setVisible(false);
  }

  async playWordInSentence() {
    const word = this.currentContext?.wordCreationPanel.currentTargetWord;
    if (!word) {
      console.error('No word found');
      return;
    }
    stopAudio();
    const student = getStudent();
    const studentId = student.id;
    if (studentId) {
      trackMixpanelEvent('Example button clicked', {
        word: word.example,
      });
    }

    this.showExampleForWord(word);
    await playWordInSentence(word);
  }

  async playWordDefinition() {
    const word = this.currentContext?.wordCreationPanel.currentTargetWord;
    if (!word) {
      console.error('No word found');
      return;
    }
    stopAudio();
    const student = getStudent();
    const studentId = student.id;
    if (studentId) {
      trackMixpanelEvent('Definition button clicked', {
        word: word.spelling,
      });
    }

    this.showDefinitionForWord(word);
    await playWordDefinition(word);
  }

  handleWordWasPlayed(payload: {
    wordCreationPanel: DuelWordCreationPanel;
    duelistIndex: number;
    wordWasValid: boolean;
    word: Word;
  }) {
    const { wordCreationPanel, duelistIndex, wordWasValid, word } = payload;
    if (wordWasValid) return;
    const cards = (wordCreationPanel as StudentGame).getAllCards();
    const ripostingDuelistIndex = (duelistIndex + 1) % 2;
    this.promptRiposte({
      wordCreationPanel: wordCreationPanel,
      attempt: this.getInput(),
      cards: cards,
      targetWord: word,
      duelistIndex: ripostingDuelistIndex,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
